/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { useState } from 'react';
import { usePopper } from 'react-popper';

import breakpoints from '@constants/breakpoints';
import analyticsTrack from '@lib/analytics/analyticsTrack';
import * as viewTypes from '@constants/tracking/viewTypes';
import styles from './styles.module.scss';

const handleTrackAnnotationViewed = (assetId, annotationModel, annotationModelId, viewType) => {
  analyticsTrack(
    'explore_image_annotation_viewed',
    {
      assetId,
      annotationModel,
      annotationModelId,
      viewType,
    },
  );
};

const handleClick = (
  assetId,
  annotationModel,
  annotationModelId,
  popUpActive,
  setPopUpActive,
) => {
  if (!popUpActive) {
    setPopUpActive(true);
    handleTrackAnnotationViewed(
      assetId,
      annotationModel,
      annotationModelId,
      viewTypes.ANNOTATION_INFO_BUBBLE,
    );
  } else {
    setPopUpActive(false);
  }
};

const handleMouseEnter = (
  assetId,
  annotationModel,
  annotationModelId,
  setPopUpActive,
) => {
  if (window.innerWidth >= breakpoints['large-tablet']) {
    setPopUpActive(true);
    handleTrackAnnotationViewed(
      assetId,
      annotationModel,
      annotationModelId,
      viewTypes.ANNOTATION_INFO_BUBBLE,
    );
  }
};

const InfoBubble = (props) => {
  const {
    annotationModel,
    annotationModelId,
    assetId,
    children,
    xCoordinate,
    yCoordinate,
  } = props;
  const [referenceElement, setReferenceElement] = useState();
  const [popperElement, setPopperElement] = useState();
  const [arrowElement, setArrowElement] = useState();
  const [popUpActive, setPopUpActive] = useState(false);
  const { styles: popperStyles, attributes } = usePopper(
    referenceElement,
    popperElement,
    {
      placement: 'top',
      modifiers: [
        {
          name: 'offset',
          options: {
            offset: [0, -13],
          },
        },
        {
          name: 'arrow',
          options: {
            element: arrowElement,
            padding: 8,
          },
        },
        {
          name: 'flip',
          options: {
            fallbackPlacements: ['bottom'],
            padding: 8,
          },
        },
        {
          name: 'preventOverflow',
          options: {
            tether: false,
          },
        },
      ],
    },
  );

  return (
    <div
      className={ styles.InfoBubble }
      onClick={ () => handleClick(
        assetId,
        annotationModel,
        annotationModelId,
        popUpActive,
        setPopUpActive,
      ) }
      onMouseEnter={ () => handleMouseEnter(
        assetId,
        annotationModel,
        annotationModelId,
        setPopUpActive,
      ) }
      onMouseLeave={ () => setPopUpActive(false) }
      ref={ setReferenceElement }
      style={{
        top: `calc(${yCoordinate * 100}%)`,
        left: `calc(${xCoordinate * 100}%)`,
        zIndex: popUpActive ? 1 : 0,
      }}
    >
      {popUpActive && (
        <div
          className={ styles.Popup }
          ref={ setPopperElement }
          style={ popperStyles.popper }
          { ...attributes.popper }
        >
          <div className={ styles.DropShadow }>
            <div
              className={ styles.Arrow }
              ref={ setArrowElement }
              style={{
                ...popperStyles.arrow,
                transform: `
                  ${popperStyles.arrow ? popperStyles.arrow.transform : ''} rotate(-45deg)
                `,
              }}
            />
            { children }
          </div>
        </div>
      )}
    </div>
  );
};

export default InfoBubble;
